import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class UserUnifiedEndpointService {
  readonly #service = inject(ServicesService);

  fetchUserData() {
    return this.#service.userService('me');
  }
}
